@if (restaurant) {
  <div (click)="this.close($event)"
    class="bg-black/50 overflow-hidden clickClose modal fixed" style="z-index: 999;">
    <div #fadeInContainer
      (animationend)="this.removeFadeInFromContainer()" class="wrapper bg-white w-full h-full max-h-[650px] max-w-[800px] rounded overflow-y-auto flex flex-col fadeIn">
      <div class="w-full p-6 relative flex items-start"
        style="background-image: url('/assets/images/modules/food-facade.webp'); background-size: cover; background-position: center;">
        <img [attr.src]="this.generateImageUrl(restaurant)" alt="Logo du restaurant" class="rounded max-h-32">
        <mk-icon-button (click)="this.onCloseClick()" class="ml-auto" direction="rtl" icon="cancel"
          [label]="this.closeText || 'Retour au choix des restaurants'" useSvg="false"/>
        </div>
        <div class="h-full w-full flex-1 overflow-y-auto p-2 flex flex-col">
          <p class="font-semibold text-xl w-full text-center">
            {{ restaurant.name }}
          </p>
          <div class="w-full flex items-stretch gap-2 mt-5">
            <div
              class="flex-1 flex flex-col border bg-gris-4 border-gris-3 rounded p-3 max-h-48 min-h-48 overflow-y-auto">
              <p class="font-semibold w-full">Informations de l'établissement</p>
              <div class="w-full flex-1 flex-col justify-center flex">
                <div class="w-full flex items-center gap-2 mt-2 text-xs">
                  <span class="material-icons fg-vert-1">
                    location_on
                  </span>
                  <div class="h-full flex-1 flex items-center justify-center">
                    <p class="w-full overflow-hidden font-semibold h-fit p-1">
                      {{ restaurant.address }}, <br/>
                      {{ restaurant.postal_code }} - {{ restaurant.city }}
                    </p>
                  </div>
                </div>
                @if (restaurant.email && restaurant.email.length > 0 ) {
                  <div
                    class="w-full flex items-center gap-2 mt-2 text-xs">
                    <span class="material-icons fg-vert-1">
                      email
                    </span>
                    <div class="h-full flex-1 flex items-center justify-center">
                      <p class="w-full overflow-hidden font-semibold h-fit p-1">
                        {{ restaurant.email }}
                      </p>
                    </div>
                  </div>
                }
                @if (this.formatPhone(restaurant.phone).length > 0) {
                  <div
                    class="w-full flex items-center gap-2 mt-2 text-xs">
                    <span class="material-icons fg-vert-1">
                      phone
                    </span>
                    <div class="h-full flex-1 flex items-center justify-center">
                      <p class="w-full overflow-hidden font-semibold h-fit p-1">
                        {{ this.formatPhone(restaurant.phone) }}
                      </p>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div
              class="flex-1 flex flex-col border bg-gris-4 border-gris-3 rounded p-3 max-h-48 min-h-48 overflow-y-auto">
              <p class="font-semibold w-full">Message de l'établissement</p>
              <div class="h-full w-full flex-1 overflow-y-scroll p-2 text-sm">
                <p class="px-2">
                  {{ this.message }}
                </p>
              </div>
            </div>
          </div>
          <div class="w-full flex-1 bg-gris-3 my-2 mb-1 rounded">
            <iframe [attr.src]="this.mapUrl" allowfullscreen class="w-full h-full" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </div>
  }
